import { render, staticRenderFns } from "./faturadizaynduzenle.vue?vue&type=template&id=2dcb5045&scoped=true&"
import script from "./faturadizaynduzenle.vue?vue&type=script&lang=js&"
export * from "./faturadizaynduzenle.vue?vue&type=script&lang=js&"
import style0 from "./faturadizaynduzenle.vue?vue&type=style&index=0&id=2dcb5045&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcb5045",
  null
  
)

export default component.exports